import React from 'react';
import styled from 'styled-components';

const FrameContainer = styled.div`
  width: ${({ width }) => width || '100mm'};
  height: ${({ height }) => height || '100mm'};
  border: 1px solid #ccc;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1mm;
  padding: 1mm;
  margin-bottom: 10mm;
  @media print {
    width: ${({ width }) => width || '100mm'};
    height: ${({ height }) => height || '100mm'};
    border: none;
    page-break-inside: avoid;
    page-break-after: always;
  }
`;

const LabelContainer = styled.div`
  border: 1px solid #ccc;
  padding: 1mm;
  width: 48mm;
  height: 23mm;
  @media print {
    width: 48mm;
    height: 23mm;
    border: 1px inset #111;
  }
`;

const LabelContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const LabelTitle = styled.h3`
  margin: 0;
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
`;

const LabelText = styled.p`
  margin: 1px 0;
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
`;

const LabelTextDate = styled.p`
  margin: 1px 0;
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
`;

const LabelTextServingdag = styled.span`
  font-size: 10px;
  font-weight: normal;
`;

const LabelTextName = styled.h3`
  margin: 1px 0;
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
`;

const PrintableLabel = ({ users, weekDay, contentOptions, frameDimensions, textStyles, mealOption }) => {
  // Number of labels per frame (2 columns x 4 labels per column = 8 labels)
  const labelsPerFrame = 8;
  // Function to convert weekday number to Swedish name
  const getSwedishWeekday = (weekdayNumber) => {
    if (weekdayNumber < 1 || weekdayNumber > 7 || !Number.isInteger(weekdayNumber)) {
      return "Ogiltig veckodag";
    }

    switch (weekdayNumber) {
      case 1:
        return "Måndag";
      case 2:
        return "Tisdag";
      case 3:
        return "Onsdag";
      case 4:
        return "Torsdag";
      case 5:
        return "Fredag";
      case 6:
        return "Lördag";
      case 7:
        return "Söndag";
      default:
        return "Ogiltig veckodag";
    }
  };

  // Convert weekDay to Swedish weekday name
  const swedishWeekDay = getSwedishWeekday(Number(weekDay));

  // Capitalize the first letter of the meal option for display
  const mealString = mealOption ? ` (${mealOption.charAt(0).toUpperCase() + mealOption.slice(1)})` : "";

  // Group users into chunks of 8 for each frame
  const frames = [];
  for (let i = 0; i < users?.length; i += labelsPerFrame) {
    frames.push(users.slice(i, i + labelsPerFrame));
  }

  return (
    <div>
      {frames.map((frameUsers, frameIndex) => (
        <FrameContainer
          key={frameIndex}
          width={frameDimensions.width}
          height={frameDimensions.height}
        >
          {frameUsers.map((user) => {
            const userAllergies = user.allergic || [];
            return (
              <LabelContainer key={user._id}>
                <LabelContent>
                  <LabelTitle
                    fontSize={textStyles.title.fontSize}
                    isBold={textStyles.title.isBold}
                  >
                    {user.username}
                  </LabelTitle>
                  {contentOptions.showServingdag && (
                    <LabelTextDate
                      fontSize={textStyles.date.fontSize}
                      isBold={textStyles.date.isBold}
                    >
                      <LabelTextServingdag>Servingdag: </LabelTextServingdag>
                      {swedishWeekDay}{mealString}
                    </LabelTextDate>
                  )}
                  {contentOptions.showServingdag && (
                    <LabelTextName
                      fontSize={textStyles.name.fontSize}
                      isBold={textStyles.name.isBold}
                    >
                      {user.person_name}
                    </LabelTextName>
                  )}
                  {contentOptions.showAllergies && userAllergies.length > 0 && (
                    <LabelText
                      fontSize={textStyles.text.fontSize}
                      isBold={textStyles.text.isBold}
                    >
                      {userAllergies.join(', ')} || Antal:{user.portion}
                    </LabelText>
                  )}
                </LabelContent>
              </LabelContainer>
            );
          })}
        </FrameContainer>
      ))}
    </div>
  );
};

export default PrintableLabel;